/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Linked_Group_LabelInputs */



/**
* | output |
* | --- |
* | "Linked Group" |
*
* @param {Edit_Event_Group_Linked_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_linked_group_label = /** @type {((inputs?: Edit_Event_Group_Linked_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Linked_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe lié")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfte Gruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo collegato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Связанная группа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo vinculado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("链接组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リンクグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिंक्ड ग्रुप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo Vinculado")
	return /** @type {LocalizedString} */ ("Linked Group")
});